import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import Index from './routes/Index';
import registerServiceWorker from './registerServiceWorker';
import {LocaleProvider} from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import {configure} from 'mobx';
import {Provider} from 'mobx-react';
import stores from './store/index';

// function reload() {
//   let t = new Date().getTime();
//   let url = window.location.href;
//   if (window.location.search) {
//     url += '&';
//   } else {
//     url += '?';
//   }
//   url += ('t=' + t);
//   window.location.href = url;
// }
// reload();

moment.locale('zh-cn');
configure({enforceActions: 'observed'});

ReactDOM.render(
  (
    <Provider {...stores}>
      <LocaleProvider locale={zh_CN}>
        <Index/>
      </LocaleProvider>
    </Provider>
  ), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js